import { ResponseCustom } from './../../../../models/ResponseCustom';

import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    AfterViewInit,
    ElementRef,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from 'src/app/models/modalConfig';
import { FileModalBilletsService } from './file-modal-billets.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReturnModalBillets } from 'src/app/models/ReturnModalBillets';
import * as _ from 'lodash';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { SearchTypeEnum } from 'src/app/components/search-person-input/search-person-input.component';

@Component({
    selector: 'file-modal-billets',
    templateUrl: './file-modal-billets.component.html',
    styleUrls: ['./file-modal-billets.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileModalBilletsComponent implements AfterViewInit {
    constructor(
        private cdRef: ChangeDetectorRef,
        private modalService: NgbModal,
        private fileModalBilletsService: FileModalBilletsService,
        private notificationsService: NotificationsService,
        private spinner: NgxSpinnerService,
        private session: SessionBusiness,
    ) {}

    @ViewChild('content6') content: ElementRef;
    @ViewChild('content7') contentPerson: ElementRef;

    @Input() showHide: ModalConfig;

    @Output() resShowHide = new EventEmitter();
    @Output() clearClose = new EventEmitter();

    resultBillets: ResponseCustom;
    differenceValue: any;
    searchOk: boolean = false;
    oldDifferenceValue = 0;
    totalToDistribute: any;
    listLinesSelected = [];
    listSelectToolTip = [];
    lastValueSelected = 0;
    valueRestDiff = 0;
    returnModalBillets: ReturnModalBillets;
    contracts: any[] = [];
    searchPersonType: SearchTypeEnum = SearchTypeEnum.PersonDocument;
    responsibleName: string = '';

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    ngOnChanges(changes: any) {
        this.cdRef.detectChanges();

        if (changes.showHide.currentValue.status) {
            if (this.showHide.element.error !== LineErrorEnum.BilletNotExist) {
                this.open(this.content, this.showHide);
            } else {
                this.responsibleName = changes.showHide.currentValue.element.responsibleName;
                this.openModalPerson(this.contentPerson);
            }
        }
    }

    open(content: any, showHide: any, personParam?: any) {
        let responsibleId;

        if (personParam) {
            responsibleId = personParam.id;
            showHide.element.responsibleId = personParam.id;
        } else {
            responsibleId = showHide.element.responsibleId;
        }

        let billetId = showHide.element.dataReceiving
            .filter((x: any) => x.billetNumber == showHide.element.billetNumber)
            .map((x: any) => x.billetIdExternal);

        var query = {
            params: {
                datePayment: showHide.element.creditDate,
                billetId: billetId,
            },
        };

        this.totalToDistribute = this.showHide.element.valuePaid - this.showHide.element.billetValue;

        if (
            this.showHide.element.error === LineErrorEnum.BilletCanceled ||
            this.showHide.element.error === LineErrorEnum.BilletPaid ||
            this.showHide.element.error === LineErrorEnum.BilletNegotiation ||
            this.showHide.element.error === LineErrorEnum.BilletCollector ||
            this.totalToDistribute == 0
        ) {
            this.differenceValue = this.showHide.element.valuePaid;
            this.totalToDistribute = this.showHide.element.valuePaid;
        } else {
            this.differenceValue = this.showHide.element.valuePaid - this.showHide.element.billetValue;
        }

        this.spinner.show();

        this.fileModalBilletsService.getBilletsByResponsible(responsibleId, query).subscribe((resultBillets) => {
            this.searchOk = true;
            if (resultBillets.typeResponse === 3) {
                this.contracts = resultBillets.data;

                this.spinner.hide();

                if (this.contracts.length > 0) {
                    this.modalService.open(content, {
                        size: 'lg',
                        keyboard: false,
                        backdrop: 'static',
                    });
                } else {
                    this.notificationsService.warn(
                        '',
                        'Não existem contratos abertos para o responsável desta parcela',
                    );
                    this.clear();
                }

                this.showHide.status = false;
                this.resShowHide.emit(this.showHide);
            } else {
                this.spinner.hide();
                this.clear();
            }
        });
    }

    openModalPerson(content: any) {
        this.modalService.open(content, {
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
        });
    }

    personSelected(ev: any) {
        this.modalService.dismissAll(this.contentPerson);
        this.open(this.content, this.showHide, ev);
    }

    selectLine(line: any) {
        var positionLinesSelected = this.listLinesSelected.indexOf(line.billetId);

        if (this.differenceValue > 0 || positionLinesSelected !== -1) {
            if (positionLinesSelected === -1) {
                this.listLinesSelected.push(line.billetId);
                this.differenceValue = this.differenceValue - line.totalOpenValue;
                this.lastValueSelected = line.totalOpenValue;

                let objTooltip = {
                    number: line.number,
                    value: line.totalOpenValue,
                    partial: false,
                };

                if (this.differenceValue < 0) {
                    this.oldDifferenceValue = _.clone(this.differenceValue);

                    this.differenceValue = 0;
                    objTooltip.partial = true;
                }

                this.listSelectToolTip.push(objTooltip);
            } else {
                if (this.differenceValue === 0) {
                    this.differenceValue = this.oldDifferenceValue + line.totalOpenValue;
                } else {
                    this.differenceValue = this.differenceValue + line.totalOpenValue;
                }

                this.listLinesSelected.splice(positionLinesSelected, 1);

                this.listSelectToolTip = _.remove(this.listSelectToolTip, function (n) {
                    return n.number != line.number;
                });
            }
        } else {
            this.notificationsService.warn('', 'Não exite difença a distribuir!');
        }
    }

    clear() {
        this.clearModal();

        this.returnModalBillets = {
            receivingLineId: this.showHide.element.id,
            clear: true,
        };

        this.clearClose.emit(this.returnModalBillets);
    }

    save() {
        if (this.differenceValue > 0) {
            this.notificationsService.alert('Valor a distribuir é maior que zero');
            return;
        }

        this.returnModalBillets = {
            receivingLineId: this.showHide.element.id,
            billetsSelected: this.listLinesSelected,
            responsibleSelected: this.showHide.element.responsibleId,
            descriptionBillets: this.listSelectToolTip,
            type: 1,
        };

        this.clearClose.emit(this.returnModalBillets);

        this.clearModal();
    }

    clearModal() {
        this.modalService.dismissAll();
        this.oldDifferenceValue = 0;
        this.differenceValue = 0;
        this.listLinesSelected = [];
        this.listSelectToolTip = [];
    }
}

const LineErrorEnum = {
    BilletNotExist: 1,
    BilletCanceled: 2,
    BilletPaid: 3,
    BilletNegotiation: 8,
    BilletCollector: 9,
};
